// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3Rgzt","error":"Textarea_error__1xx0U","readonly":"Textarea_readonly__30h2o","disabled":"Textarea_disabled__X0IpB"};